// extracted by mini-css-extract-plugin
module.exports = {"svgContainer":"styles_svgContainer__yldV_","icon":"styles_icon__Kb4Uh"};